import { Box, Link, SubTitle, Text } from "@shared/primitive-components"
import { connectivityBarStyles as styles } from "../../styles"

const CONNECTIVITY_BANNER_DTI = {
  CONNECT: `connectivity_banner_connect`,
}

const ConnectivityBarLink = ({ label, href }: { label: string; href: string }) => (
  <Link css={styles.link} data-testid={CONNECTIVITY_BANNER_DTI.CONNECT} href={href} target="_blank">
    {label}
  </Link>
)

export const NoVehiclesConnected = (isRebatePolicy: boolean) => {
  const content = isRebatePolicy ? (
    <Text>
      <ConnectivityBarLink label="Connect vehicles" href="https://flockcover.com/connect-matrix/" />
      {` `}
      to calculate your safety score and unlock rebates.
    </Text>
  ) : (
    <Text>
      <ConnectivityBarLink
        label="Connect vehicles to access Safety Insights"
        href="https://flockcover.com/connect-matrix/"
      />
      {` `}
      and see how speeding impacts safety.
    </Text>
  )

  return (
    <Box css={styles.root}>
      <SubTitle css={styles.title}>None of your vehicles are connected</SubTitle>
      {content}
    </Box>
  )
}

export const TargetNotMet = (isRebatePolicy: boolean, isRebateV2Policy: boolean) => {
  const content = isRebateV2Policy ? (
    <Text>
      To be eligible for Rebates, at least 75% of your fleet must be connected. Ensure your vehicles are always
      connected to unlock the full benefits of Flock. Need help? Visit our
      {` `}
      <ConnectivityBarLink
        label="Help Centre."
        href="https://help.flockcover.com/how-do-i-fix-issues-connecting-my-telematics-data-to-flock"
      />
    </Text>
  ) : isRebatePolicy ? (
    <Text>
      Disconnected vehicles cannot accumulate Mileage or Safety Rebates. Maximise your potential to save by
      {` `}
      <ConnectivityBarLink
        label="making sure your vehicles are always connected to Flock."
        href="https://flockcover.com/connect-matrix/"
      />
    </Text>
  ) : (
    <Text>
      <ConnectivityBarLink
        label="Connect vehicles to access Safety Insights"
        href="https://flockcover.com/connect-matrix/"
      />
      {` `}
      and see how speeding impacts safety.
    </Text>
  )

  return (
    <Box css={styles.root}>
      <SubTitle css={styles.title}>
        {isRebateV2Policy ? `Less Than 75% of Vehicles Connected` : `Less than 80% of vehicles connected`}
      </SubTitle>
      {content}
    </Box>
  )
}
